module.exports = __webpack_public_path__ + "static/img/top_bj.74963b7e.png";